"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIntl;
function getIntl() {
  return Intl;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJnZXRJbnRsIiwiSW50bCJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbmZyYXN0cnVjdHVyZS9pbnRsLWJyb3dzZXIudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gZ2V0SW50bCgpIHtcbiAgcmV0dXJuIEludGw7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFlLFNBQVNBLE9BQU9BLENBQUEsRUFBRztFQUNoQyxPQUFPQyxJQUFJO0FBQ2IiLCJpZ25vcmVMaXN0IjpbXX0=